module.exports = __webpack_public_path__ + "static/img/weapp.b20bdf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage/weapp.jpg
// module id = R0Uu
// module chunks = 0